// extracted by mini-css-extract-plugin
module.exports = {"productName__name":"Name_productName__name__rTGQp"};